const PropertyWishlist = {
  storageKey: "goprovalo_wishlist",
  csrfCookieName: "goprovalo_customer_session_csrf",

  getAll() {
    try {
      const storedValue = localStorage.getItem(
        this.storageKey
      );

      if (!storedValue) {
        return [];
      }

      const items = JSON.parse(storedValue);

      return Array.isArray(items)
        ? items.map((item) => String(item))
        : [];
    } catch (error) {
      console.error(
        "Unable to read the local wishlist:",
        error
      );

      return [];
    }
  },

  saveAll(items) {
    const normalizedItems = [
      ...new Set(
        items
          .map((item) => String(item).trim().toUpperCase())
          .filter(Boolean)
      )
    ];

    localStorage.setItem(
      this.storageKey,
      JSON.stringify(normalizedItems)
    );
  },

  isSaved(caseNumber) {
    const normalizedCaseNumber = String(
      caseNumber || ""
    )
      .trim()
      .toUpperCase();

    return this.getAll().includes(
      normalizedCaseNumber
    );
  },

  getCookie(cookieName) {
    const cookiePrefix =
      `${encodeURIComponent(cookieName)}=`;

    const matchingCookie = document.cookie
      .split(";")
      .map((item) => item.trim())
      .find((item) => item.startsWith(cookiePrefix));

    if (!matchingCookie) {
      return "";
    }

    return decodeURIComponent(
      matchingCookie.substring(cookiePrefix.length)
    );
  },

  getCsrfToken() {
    return this.getCookie(this.csrfCookieName);
  },

  async sync(caseNumber, action) {
    const csrfToken = this.getCsrfToken();

    if (!csrfToken) {
      throw new Error(
        "Please sign in before saving properties."
      );
    }

    const response = await fetch(
      "https://api.goprovalo.com/update_wishlist.php",
      {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          case_number: caseNumber,
          action
        })
      }
    );

    const responseText = await response.text();
    let result;

    try {
      result = JSON.parse(responseText);
    } catch (error) {
      console.error(
        "Invalid wishlist API response:",
        responseText
      );

      throw new Error(
        "The wishlist service returned an invalid response."
      );
    }

    if (
      response.status === 401 ||
      result.error === "customer_not_authenticated"
    ) {
      throw new Error(
        "Please sign in before saving properties."
      );
    }

    if (
      response.status === 403 &&
      result.error === "invalid_csrf_token"
    ) {
      throw new Error(
        "Your session could not be verified. Please sign in again."
      );
    }

    if (!response.ok || !result.success) {
      throw new Error(
        result.message ||
        "Unable to update the saved property."
      );
    }

    return result;
  },

  async toggle(caseNumber) {
    const normalizedCaseNumber = String(
      caseNumber || ""
    )
      .trim()
      .toUpperCase();

    if (!normalizedCaseNumber) {
      throw new Error(
        "The property case number is missing."
      );
    }

    const items = this.getAll();
    const currentlySaved = items.includes(
      normalizedCaseNumber
    );

    const action = currentlySaved
      ? "remove"
      : "add";

    /*
     * Update the server first. Local state changes only after the database
     * confirms success.
     */
    await this.sync(
      normalizedCaseNumber,
      action
    );

    let updatedItems;

    if (currentlySaved) {
      updatedItems = items.filter(
        (item) => item !== normalizedCaseNumber
      );
    } else {
      updatedItems = [
        ...items,
        normalizedCaseNumber
      ];
    }

    this.saveAll(updatedItems);

    return !currentlySaved;
  }
};